const winston = require('winston'); 
const debugLogger = new (winston.Logger)();

const consoleDebugOptions = {
  timestamp: () => new Date().toLocaleString(),
  level: 'debug',
  name: 'debug-console',
  colorize: true,
  json: false,
};

const consoleInfoOptions = {
  timestamp: () => new Date().toLocaleString(),
  level: 'info',
  name: 'info-console',
  colorize: true,
  json: false,
};

const addDebugConsole = () => {
  debugLogger.add(winston.transports.Console, consoleDebugOptions);
};

const addInfoConsole = () => {
  debugLogger.add(winston.transports.Console, consoleInfoOptions);
};

const confgureWinstonTransports = () => {
  winston.remove(winston.transports.Console);
  if (process.env.DEV === '1') addDebugConsole();
  else addInfoConsole();
};

confgureWinstonTransports();
module.exports = {
  debugLogger,
};
